// removed by extract-text-webpack-plugin
module.exports = {"form":"_2OhyERYu3Thyo921aKJKG9","title":"_3_UsXRBdDUqpcrUeEA5iUG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexForm/index.less
// module id = 372
// module chunks = 0